// copied from git@bitbucket.org:reckonhq/apsworkflow-ui.git Code/src/utils/currency-utils.ts

export function currencyStringToNumber(value: string): number {
  const cleanString = value.replace(/,/g, '').replace('$', '');
  if (cleanString.length) return parseFloat(cleanString);
  else return 0;
}

// https://stackoverflow.com/a/11832950/11569
export function roundNumberToTwoDecimalPlaces(value: number) {
  // if you're wondering about the Number.EPSILON in here, it's to make sure things like 1.005 round correctly to 1.01
  // https://stackoverflow.com/questions/11832914/round-to-at-most-2-decimal-places-only-if-necessary#comment28521418_11832950
  return Math.round((value + Number.EPSILON) * 100) / 100;
}

export function numberToCurrencyString(value: number) {
  const decimalPlaces = value === Math.trunc(value) ? 0 : 2;

  return `$${value.toLocaleString(undefined, {
    minimumFractionDigits: decimalPlaces,
    maximumFractionDigits: decimalPlaces,
  })}`;
}
